import { render, staticRenderFns } from "./BeefCattleList2023.vue?vue&type=template&id=77e1fd24&scoped=true"
import script from "./BeefCattleList2023.vue?vue&type=script&lang=js"
export * from "./BeefCattleList2023.vue?vue&type=script&lang=js"
import style0 from "./BeefCattleList2023.vue?vue&type=style&index=0&id=77e1fd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e1fd24",
  null
  
)

export default component.exports